import React, { useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Paper } from '@material-ui/core';
import { addYears, startOfDay } from 'date-fns';
import { useSelectedView } from 'reducers/viewsSlice';

import { thisQuarter } from 'constants/ProjectConstants';
import { getDateRangeFromLS } from 'constants/helper';
import { localStorageKeys } from 'constants/localStorageKeys';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange';
import { TextHeader2 } from 'uiToolkitV1/Typography';

import { useLevelUpAnalytics } from '../context';

const StyledPaper = styled(Paper)`
  background: ${(props) => props.theme.colors.neutral.F5F7F9};
  border-radius: 0;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0px 1px 4px #cfd7df;
`;

const LevelUpAnalyticsHeader = () => {
  const { updateDateRange } = useLevelUpAnalytics();

  const sideNavSelectedCohort = useSelectedView();

  useEffect(() => {
    // this is to set default date range in context.
    const dateRangeFromLS = getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters);
    updateDateRange(dateRangeFromLS ?? thisQuarter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledPaper>
      <Flex alignItems="center">
        {Boolean(sideNavSelectedCohort?.name) && (
          <TextHeader2 mr="8px" pb="2px" bold>
            {sideNavSelectedCohort?.name}&apos;s feedback for
          </TextHeader2>
        )}
        <DateRangeDropdown
          onSelect={updateDateRange}
          minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
          maxDate={addYears(startOfDay(new Date()), 5)}
          initialDateRange={getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters) ?? thisQuarter}
          showPredefinedRanges
        />
        {/* <DateRangeSelectionDropdown
          defaultDateRange={
            getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters) ?? thisQuarter
          }
          onDateRangeChange={updateDateRange}
          predefinedRanges={ANALYTICS_PREDEFINED_DATERANGES}
          minDate={subMonths(startOfDay(new Date()), 11)}
          maxDate={addMonths(startOfDay(new Date()), 11)}
          customCalendarIcon
          iconSize="tinierFixed"
        /> */}
      </Flex>
      <Flex justifyContent="flex-end" pt={2} />
      {/* <TextBodyMedium bold color={theme.colors.text.g2} sx={{ marginTop: '16px' }}>
        Insights
      </TextBodyMedium> */}
    </StyledPaper>
  );
};

export default LevelUpAnalyticsHeader;
